import { type ReactNode } from 'react';
import cn from 'classnames';
import s from './heap.module.scss';

interface IChildrenProps {
  children?: ReactNode;
}

interface IHeaderProps extends IChildrenProps {
  endIcon?: ReactNode;
  className?: string;
}

export function Small({ children }: IChildrenProps) {
  return (
    <>
      <br />
      <small className="muted">{children}</small>
    </>
  );
}

export const SectionWrapper = ({ children }: IChildrenProps) => (
  <div className={s.sectionWrapper}>{children}</div>
);

export const Header = ({ children, endIcon, className }: IHeaderProps) => (
  <div className={cn(s.header, className)}>
    {children}
    {endIcon ? <div className={s.endIcon}>{endIcon}</div> : null}
  </div>
);
